import { CellContext } from '@tanstack/react-table';
import { DataTableColumn } from '@/components/DataTable';

const NameCell = ({ getValue }: CellContext<ItemBrandColumns, string>) => {
  return (
    <div sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div sx={{ fontWeight: 'semibold', color: 'neutralDark' }}>
        {getValue()}
      </div>
    </div>
  );
};

export type ItemBrandColumns = {
  id: string;
  name: string;
  actions?: string;
};

export const brandTableColumns: DataTableColumn<ItemBrandColumns>[] = [
  {
    header: 'Brand Name',
    accessorKey: 'name',
    cell: NameCell,
  },
  {
    header: '',
    // The container keys the Edit/Delete actions off this column's id.
    accessorKey: 'actions',
  },
];
